var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight01 = function SvgArrowRight01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "arrow_right-01_svg2__a",
    x1: 19.86,
    x2: 213,
    y1: 151.51,
    y2: 54.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m198.68 96.8-45.45-45.45a4.546 4.546 0 1 0-6.41 6.41l37.68 37.73H4.55C2.04 95.48 0 97.51 0 100.02s2.04 4.55 4.55 4.55H184.5l-37.68 37.68a4.546 4.546 0 1 0 6.41 6.41l45.45-45.45a4.55 4.55 0 0 0 0-6.41",
    style: {
      fill: "url(#arrow_right-01_svg2__a)"
    }
  }));
};
export default SvgArrowRight01;